import { formatDateCs } from "./utils";

/** Formátuje čas posledního použití v jídelníčku pro UI. */
export function formatRecipeLastUsed(ts: number | null | undefined): string {
  if (ts == null || !Number.isFinite(ts)) return "nikdy";
  const d = new Date(ts);
  const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return formatDateCs(iso);
}

export type RecipeSortBy = "name" | "lastUsedAsc" | "lastUsedDesc";

export function sortRecipes<T extends { name: string; lastUsedInMealPlanAt?: number | null }>(
  recipes: T[],
  sortBy: RecipeSortBy
): T[] {
  const out = [...recipes];
  if (sortBy === "name") {
    return out.sort((a, b) => a.name.localeCompare(b.name, "cs"));
  }
  if (sortBy === "lastUsedAsc") {
    return out.sort((a, b) => {
      const ta = a.lastUsedInMealPlanAt ?? 0;
      const tb = b.lastUsedInMealPlanAt ?? 0;
      if (ta !== tb) return ta - tb;
      return a.name.localeCompare(b.name, "cs");
    });
  }
  // lastUsedDesc — null/never last
  return out.sort((a, b) => {
    const ta = a.lastUsedInMealPlanAt ?? 0;
    const tb = b.lastUsedInMealPlanAt ?? 0;
    if (ta !== tb) return tb - ta;
    return a.name.localeCompare(b.name, "cs");
  });
}
